/**
 * @generated SignedSource<<6109894b674c4438e00a4e72d9ab39e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NodeInput = {
  id: string;
};
export type FeedTabDeleteLinkMutation$variables = {
  input: NodeInput;
};
export type FeedTabDeleteLinkMutation$data = {
  readonly deleteFeedPost: {
    readonly id: string;
  };
};
export type FeedTabDeleteLinkMutation = {
  response: FeedTabDeleteLinkMutation$data;
  variables: FeedTabDeleteLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GraphQLFeedPost",
    "kind": "LinkedField",
    "name": "deleteFeedPost",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedTabDeleteLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedTabDeleteLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "087d45d0288f973bd927784f2aa38f0e",
    "id": null,
    "metadata": {},
    "name": "FeedTabDeleteLinkMutation",
    "operationKind": "mutation",
    "text": "mutation FeedTabDeleteLinkMutation(\n  $input: NodeInput!\n) {\n  deleteFeedPost(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0993a807ba81edb949209be646df10cd";

export default node;
